/** Connect Company index path. Prefer slug; fall back to search. */
export function companyPath(name?: string, slug?: string): string | undefined {
  if (slug?.trim()) return `/companies/${encodeURIComponent(slug.trim())}`;
  if (name?.trim()) return `/companies?q=${encodeURIComponent(name.trim())}`;
  return undefined;
}
